import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const InibuildsA340Seo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="The long-haul classic">
        <Text fz="medium">
          Before ETOPS cleared the skies for twin-jets, the A340 ruled the ultra-long-haul routes.
          iniBuilds brings this graceful wide-body to MSFS, and{" "}
          <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="Built for ocean crossings">
        <Text fz="medium">
          The A340's four CFM56s gave airlines the range and redundancy to connect continents
          without worry. This checklist, adapted from{" "}
          <a
            href="https://www.youtube.com/@jaydeegaming"
            target="_blank"
            data-goatcounter-click="jaydee-youtube-link"
          >
            JayDee
          </a>
          's work on{" "}
          <a
            href="https://msfschecklist.de"
            target="_blank"
            data-goatcounter-click="msfschecklist-link"
          >
            msfschecklist.de
          </a>
          , covers the full flight from power-up through securing the aircraft. Tweak it in{" "}
          <Text span c="black" fw="bold">
            fs-checklist-studio
          </Text>
          , print a PDF for your kneeboard, or share it with your virtual airline.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
